module.exports = __webpack_public_path__ + "img/13.f91efa35.jpg";